export const defaultProducto = () => {
    return {
        nombreproducto:'',
        sinonimos:'',
        componentesactivos:'',
        componentesactivosIngles:'',
        cas:'',
        estado:'',
        proveedorfabricante:'',
        uso:'',
        observacion:'',
        disposiciontratamiento:'',
        doc_sga:'',
        doc_etiqueta:'',
        fecha_etiqueta:'',
    }
}

export default {
    estados: [],
    selectedProduct: defaultProducto(),
    action: 'create',
}